import { createFileRoute, Link } from '@tanstack/react-router';
import { InfoCallout } from '../../components/documentation';
import styles from '../../components/documentation/DocContent.module.css';

export const Route = createFileRoute('/documentation/access-tokens')({
  component: AccessTokensPage,
});

function AccessTokensPage() {
  return (
    <>
      <div className={styles.breadcrumb}>Building with Interlucent</div>
      <h1 className={styles.pageTitle}>Access Tokens</h1>
      <p className={styles.pageSubtitle}>
        Platform-issued tokens returned at exchange.
      </p>

      <section className={styles.section}>
        <p className={styles.prose}>
          Access tokens are created automatically by the platform when an
          admission token is exchanged. You do not need to create or inspect
          them — the platform handles signing, expiration, and all internal
          claims.
        </p>
        <p className={styles.prose}>
          For details on how token exchange works and what the platform resolves
          during this process, see the{' '}
          <Link to="/documentation/admission-tokens" hash="token-exchange">
            Token Exchange
          </Link>{' '}
          section on the Tokens page.
        </p>

        <InfoCallout variant="info">
          Access tokens are signed by the platform (issuer{' '}
          <code className={styles.mono}>"il"</code>), carry a 1-hour
          expiration, and include everything needed to authorize and route the
          connection.
        </InfoCallout>
      </section>
    </>
  );
}
